import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import { FaFacebook } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { BsTelegram } from "react-icons/bs";
import { IoIosArrowUp } from "react-icons/io";
import {Link} from "react-scroll";

function Footer() {

    const phoneClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'phone_click'
        });
    };

    const emailClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'email_click'
        });
    };

    const facebookClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'facebook_click'
        });
    };

    const instagramClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'instagram_click'
        });
    };

    const telegramClick = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'telegram_click'
        });
    };

    return (
        <>
            <div className="fixed bottom-4 right-4 bg-[#A1E2DE] p-2 rounded-[6px] z-40 cursor-pointer">
                <Link to="top" smooth={true} offset={-70} duration={500}>
                    <IoIosArrowUp />
                </Link>
            </div>
            <footer className="py-16 bg-center bg-no-repeat bg-[linear-gradient(239deg,_#e6e47c_0%,_#46a37e_49.59%,_#009064_100%)] text-white text-center md:text-left relative overflow-hidden">
                <div className="container max-w-screen-xl mx-auto  grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 p-4 relative z-20">
                    <div>
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h4 className="text-[18px] uppercase font-medium mb-[16px]">Участь і партнерство</h4>
                            <p className="font-light  text-[16px] mb-[10px]">Iрина</p>
                            <a href="tel:+380674084524"
                               className="block font-light  text-[16px] mb-[10px] phone_click"
                               onClick={phoneClick}
                               >
                                +38 (067) 408 45 24</a>
                            <a href="mailto:i.pyrog@ekonomika.ua"
                               className="block font-light underline text-[16px] mb-[10px] phone_partner_clk_1"
                               onClick={emailClick}>
                                i.pyrog@ekonomika.ua</a>
                        </ScrollAnimation>
                    </div>
                    <div>
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h4 className="text-[18px] uppercase font-medium mb-[16px]">Питання щодо участі</h4>
                            {/*<p className="font-light  text-[16px] mb-[10px]">З питань придбання квитків*/}
                            {/*    звертатися*/}
                            {/*    в службу продажів бізнес/медіа бюро ekonomika+</p>*/}
                            <p className="font-light  text-[16px] mb-[10px]">Яна</p>
                            <a href="tel:+380672230179"
                               className="block font-light text-[16px] mb-[10px] phone_click"
                               onClick={phoneClick}>
                                +38 (067) 223 01 79</a>
                            <a href="mailto:tickets@ekonomika.ua"
                               className="block font-light underline text-[16px] mb-[10px] email_sell_clk"
                               onClick={emailClick}>
                                tickets@ekonomika.ua</a>
                            <p className="font-light  text-[16px] mb-[10px]">Світлана</p>
                            <a href="tel:+380968369409"
                               className="block font-light  text-[16px] mb-[10px] phone_click"
                               onClick={phoneClick}>
                                +38 096 836 94 09</a>
                        </ScrollAnimation>
                    </div>
                    <div>
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h4 className="text-[18px] uppercase font-medium mb-[16px]">З питань реклами:</h4>
                            <p className="font-light  text-[16px] mb-[10px]">Ірина</p>
                            <a href="tel:+380672358382 "
                               className="block font-light   text-[16px] mb-[10px] phone_click"
                               onClick={phoneClick}>
                                +38 (067) 235 83 82 </a>
                            <a href="mailto:i.skorohod@ekonomika.ua"
                               className="block font-light underline  text-[16px] mb-[10px] phone_adv_clk_1"
                               onClick={emailClick}>
                                i.skorohod@ekonomika.ua</a>
                        </ScrollAnimation>
                    </div>
                    <div>
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h4 className="text-[18px] uppercase font-medium mb-[16px]">Слідкуйте за анонсами</h4>
                            <div className="flex justify-center md:justify-start gap-6 mb-9">
                                <a href="https://www.facebook.com/delo.ua/"
                                   className="text-2xl"
                                   target="_blank"
                                   onClick={facebookClick}><FaFacebook/></a>
                                <a href="https://www.instagram.com/delo.ua/"
                                   className="text-2xl"
                                   target="_blank"
                                   onClick={instagramClick}><RiInstagramFill/></a>
                                <a href="https://t.me/delo_ua"
                                   className="text-2xl"
                                   target="_blank"
                                   onClick={telegramClick}><BsTelegram/></a>
                            </div>
                            <p className="mb-[16px]"><a href="/privacy-policy">Політика Приватності</a></p>
                            <p className="mb-[16px]"><a href="/offer">Оферта</a></p>
                        </ScrollAnimation>
                    </div>
                </div>
        
                {/*<div className="absolute top-0 left-0 w-full h-full" style={{backgroundImage: `url(${FooterFon})`,backgroundSize: 'cover%',backgroundRepeat: 'no-repeat',backgroundPosition: 'center'}}/>*/}

            </footer>
        </>
    );
}

export default Footer;